import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function BackupCodesModal({
  show,
  handleClose,
  codes = [],
  onDownload,
}) {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header className="py-3 text-dark" closeButton>
        <Modal.Title className="fw-bold text-dark">
          Save Your Backup Codes
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="text-muted small mb-3">
          Please save these backup codes along with your authenticator app.
          Each code can only be used once if you lose access to your
          authenticator.
        </p>

        <div
          className="d-flex flex-wrap border rounded p-3 mb-3"
          style={{ gap: "8px", background: "#f8f9fa" }}
        >
          {codes.length === 0 ? (
            <span className="text-muted small">No backup codes available</span>
          ) : (
            codes.map((code, idx) => (
              <span
                key={idx}
                className="badge bg-white text-dark border"
                style={{
                  flex: "1 1 45%",
                  fontFamily: "monospace",
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  padding: "8px",
                }}
              >
                {code}
              </span>
            ))
          )}
        </div>

        <Button
          variant="primary"
          className="w-100 mb-2"
          onClick={onDownload}
          disabled={codes.length === 0}
        >
          Download Codes
        </Button>

        <Button
          variant="link"
          className="w-100 text-muted"
          onClick={handleClose}
        >
          I've saved these, continue to login
        </Button>
      </Modal.Body>
    </Modal>
  );
}